package com.wintermar.inspection.core.ui.component.badge.variant

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.Dp

data class BadgeVariantModel(
    val color: BadgePaletteModel,
    val size: BadgeSizeModel
)

data class BadgeColorModel(
    val default: BadgePaletteModel,
    val strong: BadgePaletteModel
)

data class BadgePaletteModel(
    val backgroundColor: Color = Color.Transparent,
    val textColor: Color,
    val borderColor: Color = Color.Transparent,
    val iconColor: Color
)

data class BadgeSizeModel(
    val iconSize: Dp,
    val verticalPadding: Dp,
    val horizontalPadding: Dp
)
